import $ from "jquery"

// Plans page: Monthly/Annual toggle + coupon apply.
//
// Both the monthly and annual card sets are pre-rendered (see
// app/views/home/plans.html.erb). Switching billing period just shows the
// matching grid and hides the other — NO page reload — and updates the URL via
// history.replaceState so the choice survives a refresh. Applying a coupon
// still navigates, because it needs a server-side Stripe coupon lookup.
const initPlansBillingToggle = () => {
  const $pricingPage = $(".pricing-page")
  if (!$pricingPage.length) return

  // One-time: a coupon held in the session but not yet in the URL. Reflect it in
  // the query string once, then reload so the server can price it in.
  const shouldApplySessionCoupon = $pricingPage.data("should-apply-session-coupon")
  const sessionCoupon = $pricingPage.data("session-coupon")
  if (shouldApplySessionCoupon && sessionCoupon) {
    const url = new URL(window.location)
    url.searchParams.set("coupon_code", sessionCoupon)
    url.searchParams.set("coupon_applied", "true")
    window.history.replaceState({}, "", url.toString())
    window.location.reload()
    return
  }

  const $billingToggle = $("#billingToggle")
  const $billingLabels = $(".billing-toggle-wrapper .toggle-label")
  const $grids = $(".billing-grid")

  // Seamless switch: show one pre-rendered grid, hide the other, sync labels and
  // the URL — without reloading.
  const showBilling = (billing) => {
    $grids.each(function () {
      const $g = $(this)
      $g.prop("hidden", $g.data("billing") !== billing)
    })
    $billingLabels.each(function () {
      const $l = $(this)
      $l.toggleClass("active", $l.data("billing") === billing)
    })
    const url = new URL(window.location)
    url.searchParams.set("billing", billing)
    window.history.replaceState({}, "", url.toString())
  }

  if ($billingToggle.length) {
    $billingToggle.off("change.plansToggle").on("change.plansToggle", function () {
      showBilling($(this).is(":checked") ? "annual" : "monthly")
    })
  }

  $billingLabels.each(function () {
    const $label = $(this)
    $label.off("click.plansToggle keypress.plansToggle")

    $label.on("click.plansToggle", () => {
      const billing = $label.data("billing")
      if ($billingToggle.length) $billingToggle.prop("checked", billing === "annual")
      showBilling(billing)
    })

    $label.on("keypress.plansToggle", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault()
        $label.trigger("click")
      }
    })
  })

  // Coupon apply — still navigates (needs server-side Stripe coupon validation).
  const $couponInput = $("#couponCode")
  const $applyCouponBtn = $("#applyCouponBtn")
  const $couponMessage = $("#couponMessage")

  const showCouponMessage = (message, type) => {
    if (!$couponMessage.length) return
    $couponMessage.text(message)
    $couponMessage.attr("class", `coupon-message ${type}`)
    $couponMessage.show()
    setTimeout(() => { $couponMessage.hide() }, 3000)
  }

  if ($applyCouponBtn.length) {
    $applyCouponBtn.off("click.plansToggle").on("click.plansToggle", () => {
      const couponCode = ($couponInput.val() || "").trim()
      if (!couponCode) {
        showCouponMessage("Please enter a coupon code", "error")
        return
      }
      const url = new URL(window.location)
      url.searchParams.set("coupon_code", couponCode)
      if ($billingToggle.length && $billingToggle.is(":checked")) {
        url.searchParams.set("billing", "annual")
      }
      window.location.href = url.toString()
    })
  }

  if ($couponInput.length) {
    $couponInput.off("keypress.plansToggle").on("keypress.plansToggle", (event) => {
      if (event.key === "Enter") {
        event.preventDefault()
        if ($applyCouponBtn.length) $applyCouponBtn.trigger("click")
      }
    })
  }
}

$(initPlansBillingToggle)
document.addEventListener("turbo:load", initPlansBillingToggle)
